import "./teammates.scss";
import { TeamMatesConfig } from "./teamMatesConfig";
import TeamMatesCard from "./TeamMatesCard";
import { TeamMateActionType, TeamMateAvailability } from "./types";

interface Props {
  onSelect: (
    selected: (typeof TeamMatesConfig)[0],
    action: TeamMateActionType
  ) => Promise<boolean | undefined>;
  client: keyof typeof TeamMateAvailability;
}

const TeamMates = ({ onSelect, client }: Props) => {
  return (
    <div className="teammates">
      <div className="al-grid al-grid-cols-1 md:al-grid-cols-2 lg:al-grid-cols-3 al-gap-4">
        {TeamMatesConfig.map(config => (
          <TeamMatesCard key={config.name} config={config} client={client} onSelect={onSelect} />
        ))}
      </div>
    </div>
  );
};

export default TeamMates;
